// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1H0wR","icon":"styles_icon__3SxU5"};